import React from 'react';
import { RegisterFormTooltipProvider } from 'src/context/RegisterFormTooltipContext';

const withRegisterFormTooltips = (Component, options = {}) => {
  const config = typeof options === 'string' ? { defaultTooltip: options } : options;
  const {
    defaultTooltip = 'Isi data sesuai kebutuhan field ini.',
    enabled = true,
  } = config;

  const Wrapped = (props) => (
    <RegisterFormTooltipProvider defaultTooltip={defaultTooltip} enabled={enabled}>
      <Component {...props} />
    </RegisterFormTooltipProvider>
  );

  return Wrapped;
};

export default withRegisterFormTooltips;

